import { html } from 'lit'
import HHQuizElement from '../element.js'

/**
 * 404 view
 * @extends
 */

class HHQuizView404 extends HHQuizElement {
  /**
   * Renders the current route
   * @returns {TemplateResult}
   */
  render() {
    return html`<div>404. Not found</div>`
  }
}

customElements.define('hh-quiz-not-found', HHQuizView404)
